import { CommitmentRepeatPeriod } from "../projects/CommitmentRepeatPeriod";
import { CommitmentType } from "../projects/CommitmentType";
import { ChannelCostType } from "./ChannelCostType";
import { ChannelMetadataType } from "./ChannelMetadataType";
import { CampaignStatus } from "./CampaignStatus";

export interface CampaignGridView {
  ChannelId: number;
  ClientId?: number;
  PhoneID?: number;
  TenantId: number;

  Active: boolean;
  AlertsCount: number;
  AllAssetsExternalApi: boolean;
  AverageClickCost: number;
  AverageImpressionCost: number;
  AverageLeadCost: number;
  AverageViewCost: number;
  AverageVisitorCost: number;
  AvgCostTemplate: string;
  Budget: number;
  BudgetMedia?: number;
  BudgetString: string;
  BudgetToolTip: string;
  BudgetWeather?: number;
  CRMName: string;
  CTR: number;
  CallsCount?: number;
  ChannelMetadataType: ChannelMetadataType;
  ChannelMetadataTypeId: number;
  ChannelMetadataTypeString: string;
  ChannelStatus: CampaignStatus;
  ChannelTitle: string;
  ClickCount?: number;
  ClicksOrViews: number;
  ClicksToLeads: number;
  ClientLeadAveragePrice: number;
  ClientTitle: string;
  CommitmentRepeatPeriodID: CommitmentRepeatPeriod;
  CommitmentTypeID: CommitmentType;
  Commitments: string;
  Connected: boolean;
  Conversion: number;
  Cost?: number;
  CostTypeHumanize: ChannelCostType;
  CostTypeID: number;
  CurrentGoal: number;
  DailyGoal: number;
  Days: number;
  DealAmount?: number;
  DealCount?: number;
  DefaultAssetTitle: string;
  DefaultAssetUrl: string;
  EnableCRM: boolean;
  EndDate?: Date;
  ExpectedBudget: number;
  ExpectedGoal: number;
  ExternalTokenInvalidUpdateTime?: Date;
  ExternalTokenValid: boolean;
  FbOptimizationGoal: string;
  FbPlacements: string;
  Frequency: number;
  Goal: number;
  GoalString: string;
  GoalToolTip: string;
  GoalWeather?: number;
  ImpressionCount?: number;
  Impressions1kPrice: number;
  IsAutoCreated: boolean;
  LeadCount?: number;
  LeadsToMeetings: number;
  MeetingCount?: number;
  MeetingsToDeals: number;
  NotActiveDate?: Date;
  Phone: string;
  RedirectPhone: string;
  SMSNumber: string;
  StartDate?: Date;
  StatusStr: string;
  TokenValid: boolean;
  TokenValidUpdateTime?: Date;
  TotalWeather?: number;
  ViewCount?: number;
  VisitorCount?: number;
  VisitorRate: number;
  WhatsAppPhone: string;

  // not mapped properties
  Color?: string;
}

export enum RefreshGridMode {
  None,
  Full,
  GraphsOnly,
  GridOnly
}
